export default "/images/logo-16.png?286f0358f3db5353abe81b207cfd638e";